import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-slate-800 text-white p-4 text-center">
      <div className="max-w-5xl mx-auto">
        <p>Alexander Donoho | Owings Mills, MD | (904) 378-6464 | alex@madlab.science</p>
        <p className="text-sm text-slate-400 mt-1">This interactive resume demonstrates instructional design principles in action.</p>
      </div>
    </footer>
  );
};

export default Footer;
